<body>
<div class="header">
    <span>
        <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
    </span>
</div>
<section class="wrapper">
    <div class="container-contactos">
        <div class="content">
            <div class="container card" style="background-color: white !important; border-radius: 15px !important;">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                            <h1 class="title-section">CONTACTOS DOM</h1>
                            <hr style="width: 90%;">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="row" style="text-align: left;">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <h3>Expedientes y Otras Solicitudes</h3>
                        <p>
                            Departamento de Edificación:<a href="mailto:marcela.diaz@mpuentealto.cl">marcela.diaz@mpuentealto.cl</a> Telf: 228101638<br>
                            Departamento de Urbanismo: <a href="mailto:claudia.fernandois@mpuentealto.cl">claudia.fernandois@mpuentealto.cl</a> Telf:228101779<br>
                            Departamento de Vivienda Social: <a href="mailto:katty.marin@mpuentealto.cl">katty.marin@mpuentealto.cl</a> Telf: 228101902
                        </p>
                        <h3>Certificación, Catastro y Archivo</h3>
                        <p>
                            Certificación Urbanística: <a href="mailto:paola.infanta@mpuentealto.cl">paola.infanta@mpuentealto.cl</a> Tel: 228101708<br>
                            Catastro: <a href="mailto:patricio.basoalto@mpuentealto.cl">patricio.basoalto@mpuentealto.cl</a> Tel: 228101721<br>
                            Archivo: <a href="mailto:romina.berrios@mpuentealto.cl">romina.berrios@mpuentealto.cl</a> Tel: 228101717<br>
                            Oficina de Impuesto Territorial Municipal: <a href="mailto:anamaria.gajardo@mpuentealto.cl">anamaria.gajardo@mpuentealto.cl</a> Tel: 228101915
                        </p> 
                        <h3> Denuncias de obras, inspección, BNUP y alumbrado público:</h3>
                        <p>
                            Departamento de Inspección DOM: <a href="mailto:mariangel.zamorano@mpuentealto.cl">mariangel.zamorano@mpuentealto.cl</a> Telf: 228101774<br>
                            Departamento de Construcción: <a href="mailto:hector.mera@mpuentealto.cl">hector.mera@mpuentealto.cl</a> Telf: 228101629<br>
                            Alumbrado Público: <a href="mailto:miguel.verdugo@mpuentealto.cl">miguel.verdugo@mpuentealto.cl</a> Telf: 228101796
                        </p> 
                        <h3> Oficina de partes, transparencia y coordinación:</h3>
                        <p>
                            Oficina de Partes: <a href="mailto:lindsay.avila@mpuentealto.cl">manueljose.undurraga@mpuentealto.cl</a> Telf: 228101906<br>
                            Coordinación DOM: <a href="mailto:mariateresa.derpich@mpuentealto.cl">mariateresa.derpich@mpuentealto.cl</a>  Telf: 228101763
                        </p>
                        <h3> Dirección:</h3>
                        <p>
                            Secretaria: Verónica Henríquez <a href="mailto:verónica.henriquez@mpuentealto.cl">verónica.henriquez@mpuentealto.cl</a> Tef: 228101619
                        </p>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </div>
    </div>
</section>
</body>
